import { createSelector } from 'reselect';

import { REQUEST_DATE_FORMATTER } from 'constants/StatisticsConstants';
import type { AuditInFilesRequestParams } from 'modules/statistics/types/auditInFiles';
import { getSelectedDealerGroupId, getSelectedDealerId } from 'selectors/dealerSelectors';

import { getDealersStatsFilters, getPeriod } from './ui';

export const getAuditInFilesRequestParams = createSelector(
  getPeriod,
  getSelectedDealerId,
  getSelectedDealerGroupId,
  getDealersStatsFilters,
  (
    { from, to }: { from: string; to: string },
    dealerId: string,
    groupId: string,
    { brandIds, countryCodes, modules }: { brandIds?: string[]; countryCodes?: string[]; modules: string[] }
  ): AuditInFilesRequestParams => ({
    ...REQUEST_DATE_FORMATTER.DEFAULT.transform(from, to),
    dealerId: dealerId || undefined,
    groupId: groupId || undefined,
    brands: brandIds,
    countryCodes,
    modules,
  })
);
